import { PersonaConfig } from '../types';

export const winterSportsPersona: PersonaConfig = {
  id: 'wintersports',
  name: 'Winter Sports',
  icon: '⛷️',
  description: 'Snowfall, snow depth, freezing levels, wind chill, and mountain temperatures.',
  accentColor: '#0284c7',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'single_location_only',
    hideAstronomicalEvents: true,
    showMilkyWayArButton: false,
  },
  mapDefaults: {
    recommendedPrimaryLayer: 'snow_depth',
    enabledOverlays: [],
  },
};
